<ngx-spinner></ngx-spinner>
<section class="promotional_sect login-page">
  <a routerLink="" class="cross-icon">
    <span class="icon-close"></span>
  </a>
  <div class="content_sect">
    <div class="content_text">
      <div class="content_box">
        <div class="left-content">
          <img src="assets/images/logo-white.svg" />
          <div class="login-info">
            <h2 class="mb-2 font-bold">Welcome to Intelligens</h2>
            <h4 class="mb-2 font-bold">
              Stream real shows. Real shows that matter
            </h4>
            <h6 class="content-desk mb-3">
              This is your new home for reality shows with no scripts and
              documentaries with no filters. At Intelligens, we are dedicated to
              bringing you content that is not only entertaining but will also
              offer you a look into worlds you didn't even know existed. Join us
              today and become a part of the Intelligens family.
            </h6>
            <a routerLink="/signup" href="javascript:void(0)" class="btn btn-theme text-capitalize">{{
              "LOGIN_INFO.SIGN_UP" | translate }}
            </a>
          </div>
        </div>

        <div class="right-login">
          <div class="w-100">
            <form (ngSubmit)="forgot(forgotForm.valid)" class="login" #forgotForm="ngForm">
              <div class="form-group position-relative mb-4">
                <label> {{ "FORGOT_PASSWORD.EMAIL" | translate }}</label>
                <div class="field-icon">
                  <span class="mdi mdi-email-outline"></span>
                </div>
                <!-- <input type="text" class="form-control  no-icon-field text-fields-gray" placeholder="Enter email address" [(ngModel)]="model.email" name="email" #email="ngModel" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}$" required /> -->
                <input
                  maxlength="255"
                  type="email"
                  class="
                    form-control
                    with-icon-field
                    no-icon-field
                    text-fields-gray
                  "
                  placeholder="{{
                    'FORGOT_PASSWORD.PLACEHOLDER_EMAIL' | translate
                  }}"
                  [(ngModel)]="model.email"
                  name="email"
                  #email="ngModel"
                  pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-zA-Z]{2,8}$"
                  required
                />
                <div
                  style="color: red"
                  class="validation_div"
                  *ngIf="
                    email.errors &&
                    (email.dirty || email.touched || forgotForm.submitted)
                  "
                >
                  <p class="mb-0" *ngIf="email.errors.required">
                    {{ "FORGOT_PASSWORD.EMAIL_REQUIRED" | translate }}
                  </p>
                  <p class="mb-0 red-text" *ngIf="email.errors.pattern">
                    {{ "FORGOT_PASSWORD.ENTER_VALID_EMAIL" | translate }}
                  </p>
                </div>
              </div>

              <div class="form-group text-center">
                <button
                  class="btn btn-theme btn-login"
                  href="javascript:void(0)"
                  type="submit"
                >
                  <span class="spin icon-loader" *ngIf="isLoading"> </span>
                  {{ "FORGOT_PASSWORD.SEND" | translate }}
                </button>
              </div>
            </form>
            <div class="bottom-signup text-center">
              <a
                routerLink="/login"
                href="javascript:void(0)"
                class="orange-link"
              >
                {{ "FORGOT_PASSWORD.BACK_TO_LOGIN" | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
